module.exports = __webpack_public_path__ + "media/img/pay-2-e0ad7d6f666b7c1fa55151575a0d65c4.svg";